import {useId} from "react";
import {Controller, UseControllerProps, useFormContext} from "react-hook-form";
import {GroupBase} from "react-select";

import {ISelectFieldProps, SelectField} from "@pg-design/inputs";

type IProps<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>> = Omit<
    ISelectFieldProps<Option, IsMulti, Group>,
    "value"
> & {
    name: string;
    rules?: UseControllerProps["rules"];
};

export function SelectFieldControlled<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
    props: IProps<Option, IsMulti, Group>
) {
    const {name, rules, ...selectFieldProps} = props;
    const {control} = useFormContext();

    return (
        <Controller
            name={name}
            rules={rules}
            control={control}
            render={({field, fieldState: {error}}) => {
                const fieldError = error && error.message;
                const {ref: _ref, ...fieldProps} = field;

                return <SelectField {...fieldProps} {...selectFieldProps} value={field.value} error={fieldError} instanceId={useId()} />;
            }}
        />
    );
}
